/**
 * 하단 탭바를 숨길지 한 번의 scroll 로 판단한다. 내리면 숨기고(true), 올리면 보인다(false).
 *
 * iOS 는 끝에서 더 당기면 scrollTop 이 0 아래·끝 너머로 갔다가 튕겨 돌아온다. 맨 위에서 튕겨
 * 돌아오는 움직임을 '내림'으로 읽으면 탭바가 사라진다(2026-09-23 보고). 그래서 튕김 구간은
 * 무시하고, 맨 위에 닿으면 언제나 보인다. 관성 스크롤의 잔떨림은 12px 문턱으로 거른다.
 */
export const SCROLL_STEP_PX = 12;

export function scrollStep(anchor: number, scrollTop: number, maxScroll: number): { anchor: number; hidden?: boolean } {
  if (scrollTop < 0 || scrollTop > Math.max(0, maxScroll)) return { anchor };
  if (scrollTop <= 0) return { anchor: 0, hidden: false };
  if (Math.abs(scrollTop - anchor) < SCROLL_STEP_PX) return { anchor };
  return { anchor: scrollTop, hidden: scrollTop > anchor };
}
